// Graphql usually does translation from uppercase to lowercase, but capture portal doesn't use graph
export const PASSPORT = "passport";
export const DRIVERS_LICENSE = "driver_license";
export const ID_CARD = "id_card";
export const OTHER = "other";
export const CERTIFICATE_OF_CITIZENSHIP = "certificate_of_citizenship";
